<template>
	<!-- 个人首页 -->
	<div class="wid-12">
		<div class="" style="" v-show="$route.meta.showFather">
			<div class="box-shadow">
				<div class="pad-1 mb-16">
					<div class="flex-1 jus-bet mb-24">
						<div class="flex-1 jus-bet">
							<div class="left-icon"></div>
							<p class="record-1">我的会员</p>
						</div>
						<div class="flex-1 jus-bet" @click="record">
							<p class="record">会员记录</p>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
					<!-- <div class="flex-1 jus-bet vipp mb-16" v-for="(item,index) in leveList" :key="index">
                        <div>
                            <p>会员名称</p>
                            <p>{{item.memberName}}</p>
                        </div>
                        <div>
                            <p>观看课程权限</p>
                            <p>{{item.limitsStatus == true?'已开通':'未开通'}}</p>
                        </div>
                        <div>
                            <p>已解锁名额</p>
                            <p>{{item.lockNum}}位</p>
                        </div>
                        <div>
                            <p>剩余解锁名额</p>
                            <p>{{item.endLockNum}}位</p>
                        </div>
                        <div></div>
                    </div> -->
					<div class="flex-1 jus-bet vipp mb-16">
						<div>
							<p>会员有效期</p>
							<p>{{leveList.expiredAt}}</p>
						</div>
						<div>
							<p>观看课程权限</p>
							<p>{{leveList.limitsStatus == true?'已开通':'未开通'}}</p>
						</div>
						<div>
							<p>已解锁名额</p>
							<p>{{leveList.lockNum}}位</p>
						</div>
						<div>
							<p>剩余解锁名额</p>
							<p>{{leveList.endLockNum}}位</p>
						</div>
						<div></div>
					</div>
				</div>
			</div>
			<div class="box-shadow" style="margin-bottom: 20px;padding-bottom: 20px;">
				<div class="mb-16" style="padding-top: 20px;margin-left: 10px;">
					<div class="flex-1 jus-bet mb-24">
						<div class="flex-1 jus-bet">
							<div class="left-icon"></div>
							<p class="record-1">课酬区间（每半天）</p>
						</div>
						<div class="flex-1 jus-bet">

						</div>
					</div>
				</div>
				<div class="member-list">
					<div class="member-item" v-for="(item,index) in typeList" :key="index">
						<span class="member-span">{{item.name}}</span>
						<img class="member-img" :src="item.content" mode=""></img>
					</div>
				</div>
			</div>
			<div class="pad-1 mb-16 box-shadow" v-if="leveList.notificationUrl!=null">
				<div class="flex-1 mb-16">
					<img src="../../../assets/myself/Framehui.png" alt="">
					<p class="hui">《会员权益与义务告知书》</p>
				</div>
				<img :src="leveList.notificationUrl" alt="" style="width: 100%;">

			</div>
			<div class="pad-1 box-shadow mb-24" v-if="leveList.notificationUrl==null">
				<div class="flex-1 mb-24">
					<div class="left-icon"></div>
					<p class="record-1">上传告知书</p>
				</div>
				<div>
					<el-upload class="avatar-uploader" :action="imgBaseUrl +'/infra/file/upload'"
						:show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<!-- 跨域访问后端的路径，action一定要加api；否则跨域访问会失败，然后就报错。 -->
						<img :src="imageUrl?imageUrl:require('../../../assets/photo.png')" class="unPhoto mb-24" alt="">
						<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div> -->
					</el-upload>
				</div>
				<p class="tishi">上传后表明您已知晓会员权益和义务</p>
			</div>
			<div class="flex-1 jus-bet mb-24">
				<div></div>
				<el-button type="primary" @click="applyVip">继续开通会员</el-button>
				<div></div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		getMyLevel,
		getNotification
	} from '@/api/personal/api.js';
	import {
		getSystemType
	} from '@/api/api.js';
	import moment from 'moment';
	export default {
		components: {},
		data() {
			return {
				leveList: '',
				imgBaseUrl: 'https://www.zgjyzjw.com/beishida/app-api',
				imageUrl: '',
				idUpdate: '',
				upImg: '../../../assets/photo.png',
				typeList: [],
			}

		},
		created() {
			this.userInfo = this.$store.state.activity.user;
		},
		mounted() {
			this.getMyVIP();
			this.docTitle = localStorage.getItem('docTitle');
			this.getTypeList();
		},
		methods: {
			getMyVIP() {
				getMyLevel().then(res => {
					let data = res.data;
					let tmp = {
						expiredAt: '',
						limitsStatus: false,
						lockNum: 0,
						endLockNum: 0
					};
					let minStart = 0;
					let term = 0;
					let lockNum = 0;
					let endLockNum = 0;
					for(var key in data) {
						var item = data[key];
						if (item.status==false) {
							continue;
						}
						lockNum = lockNum + item.lockNum;
						endLockNum = endLockNum + item.endLockNum;
						term = term + item.term;
						if (minStart==0) {
							minStart = item.startTime;
						}
						if (item.startTime<minStart) {
							minStart = item.startTime;
						}
						if (item.limitsStatus==true) {
							tmp.limitsStatus = true;
						}
					}
					tmp.lockNum = lockNum;
					tmp.endLockNum = endLockNum;
					let startDateTime = new Date(minStart);
					startDateTime.setMonth(startDateTime.getMonth() + term);
					tmp.expiredAt = moment(startDateTime).format("YYYY-MM-DD HH:mm:ss");
					this.leveList = tmp;
					this.idUpdate = res.data[0].id;
				})
			},
			getTypeList() {
				getSystemType({
					type: 4
				}).then(res => {
					this.typeList = res.data;
				})
			},
			applyVip() {
				this.$router.push('/personal/member/activateMembership')
			},
			record() {
				this.$router.push("/personal/member/record");
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			handleAvatarSuccess(res, file) {
				console.log(res)
				this.imageUrl = URL.createObjectURL(file.raw);
				this.upDate(res.data);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			upDate(notificationUrl) {
				let params = {
					id: this.idUpdate,
					notificationUrl: notificationUrl
				}
				getNotification(params).then(res => {
					console.log(res, '--')
					if (res.code == 0) {
						this.$message.success('更新成功')
					}
				})
			},
		}
	}
</script>

<style>

</style>
<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-1 {
		padding: 32px 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
		margin-right: 10px;
	}

	.record {
		font-size: 14px;
		color: #333333;
		line-height: 21px;
		font-family: font3;
		margin-right: 8px;
	}

	.record-1 {
		font-size: 20px;
		color: #222222;
		font-family: font5;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.vipp div p:first-child,
	.tishi {
		font-family: font3;
		color: #666666;
		font-size: 14px;
		margin-bottom: 8px;
	}

	.vipp div p:last-child,
	.hui {
		font-family: font5;
		color: #222222;
		font-size: 16px;
	}

	.unPhoto {
		width: 5.5rem;
		height: 5.5rem;
	}

	.tishi {
		color: #FF4E33 !important;
	}

	.el-button--primary {
		background-color: #3377FF;
		color: #ffffff;
		border-radius: 35px 35px 35px 35px;
		width: 40%;
	}

	.el-button--primary span {
		font-size: 16px;
		font-family: font3;
	}

	.member-list {
		width: 97%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		margin: auto;
	}


	.member-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 42%;
		height: 68px;
		border-radius: 8px;
		padding: 0 16px;
		border: 1px solid #F3F3F3;
		margin-bottom: 8px;
	}


	.member-span {
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: bold;
		font-size: 18px;
		color: #222222;
	}

	.member-img {
		width: 64px;
		height: 64px;
	}
</style>